import { FormControl, FormArray, Validators,FormBuilder } from '@angular/forms';
import { StoreService } from '@teem/models/store-service';
import { ServiceAddon } from '../models/service-addon';
import { ServiceAddonForm } from './service-addon-form';

export class StoreServiceForm {

  uuid = new FormControl(null);
  name = new FormControl(null, [Validators.required]);
  name_ar = new FormControl(null);
  service_number = new FormControl(null, [Validators.required]);
  category_id = new FormControl(null, [Validators.required]);
  price = new FormControl(0, [Validators.required, Validators.min(0.01)]);
  quantity = new FormControl(null, [Validators.required, Validators.min(1)]);
  discount_percent = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  net_price = new FormControl(null);
  description = new FormControl(null);
  description_ar = new FormControl(null);
  category = new FormControl(null);
  active = new FormControl(1);
  add_ons = new FormArray([]);

  constructor(storeService: StoreService) {
    if (storeService) {

      this.uuid.setValue(storeService.uuid);
      this.name.setValue(storeService.name);
      this.name_ar.setValue(storeService.name_ar);
      this.service_number.setValue(storeService.service_number);
      this.category_id.setValue(storeService.category_id);
      this.price.setValue(storeService.price);
      this.quantity.setValue(storeService.quantity);
      this.discount_percent.setValue(storeService.discount_percent);
      this.net_price.setValue(storeService.net_price);
      this.description.setValue(storeService.description);
      this.description_ar.setValue(storeService.description_ar);
      this.active.setValue(storeService.active);
      if (storeService.category) {
        this.category.setValue(storeService.category);
      }

      if (storeService.add_ons && storeService.add_ons.length) {
        let fb = new FormBuilder();
        storeService.add_ons.forEach((addon) => {
          this.add_ons.push(
            fb.group(new ServiceAddonForm(new ServiceAddon(addon)))
          )
        })
      }
    }
  }

}